module.exports = __webpack_public_path__ + "img/xingqiu.5e366927.webp";